import { buildTicketAbonoApartadoParts } from "./ticketAbonoApartadoEscape";

const CORTE_PAPEL = [0x1D, 0x56, 0x00];

const esCortePapel = (parte) =>
    parte instanceof Uint8Array &&
    parte.length >= 3 &&
    parte[parte.length - 3] === CORTE_PAPEL[0] &&
    parte[parte.length - 2] === CORTE_PAPEL[1] &&
    parte[parte.length - 1] === CORTE_PAPEL[2];

export const buildTicketAcuseEntregaPersonalizadoParts = ({
    entrega,
    parametrosCajaForm,
    formatearImporte,
}) => {
    // Heredamos el ticket personalizado de abonos.
    const resultado = buildTicketAbonoApartadoParts({
        abono: entrega,
        parametrosCajaForm,
        formatearImporte,
    });

    const encoder = new TextEncoder();

    // Copia independiente para no modificar el resultado original.
    const partes = [...resultado.partes];

    // El generador original termina con un comando de corte.
    // Lo retiramos para insertar el acuse antes de cortar.
    const ultimaParte = partes[partes.length - 1];

    if (esCortePapel(ultimaParte)) {
        partes.pop();
    } else {
        throw new Error(
            "No se encontró el corte final del ticket de abono"
        );
    }

    // Reemplazamos únicamente el título del comprobante.
    const tituloOriginal = encoder.encode("RECIBO DE ABONO");
    const tituloAcuse = encoder.encode("ACUSE DE ENTREGA");

    partes.forEach((parte, indice) => {
        const texto = new TextDecoder().decode(parte);

        if (texto.includes("RECIBO DE ABONO")) {
            partes[indice] = encoder.encode(
                texto.replace(
                    "RECIBO DE ABONO",
                    "ACUSE DE ENTREGA"
                )
            );
        }
    });

    // Constancia adicional de entrega definitiva.
    // Restauramos los estilos ESC/POS para evitar heredar
    // tamaños ampliados de las secciones anteriores.
    const acuse = [
        "\x1B\x40",          // Inicializar estilos de impresora
        "\x1B\x21\x00",      // Fuente normal, tamaño estándar
        "\x1D\x21\x00",      // Multiplicadores de ancho y alto normales
        "\x1B\x4D\x00",      // Fuente A
        "\x1B\x45\x00",      // Negrita desactivada
        "\x1B\x61\x01",      // Centrado

        "--------------------------------\n",

        "\x1B\x45\x01",      // Negrita activada
        "ENTREGA COMPLETA\n",
        "\x1B\x45\x00",      // Negrita desactivada

        "\n",
        "__________________________\n",
        "FIRMA DEL CLIENTE\n",
        "(Nombre y fecha)\n",
        "\n",

        "\x1B\x61\x00",      // Alineación izquierda
        "Recibi de conformidad la mercancia\n",
        "descrita arriba en buen estado\n",
        "y acepto las condiciones de cambios\n",
        "en plazos no mayores a 15 dias.\n",
        "--------------------------------\n",
        "\n\n\n",
    ].join("");

    partes.push(encoder.encode(acuse));

    // Corte final del comprobante.
    partes.push(encoder.encode("\n\n\n"));
    partes.push(Uint8Array.from(CORTE_PAPEL));

    return { partes };
};